import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FactorService {

    endpoint = environment.apiUrl + 'Evaluacion/factores/';
    endpoint2 = environment.apiUrl + 'Evaluacion/factores/buscar';
    endpoint3 = environment.apiUrl + 'Evaluacion/factores/tabla';
    endpoint4 = environment.apiUrl + 'Evaluacion/mitigantes/buscar';
    endpoint5 = environment.apiUrl + 'Evaluacion/mitigantes';

    // endpoint = 'https://localhost:5211/factores/';
    // endpoint2 = 'https://localhost:5211/factores/buscar';
    // endpoint3 = 'https://localhost:5211/factores/tabla';
    // endpoint4 = 'https://localhost:5211/mitigantes/buscar';
    // endpoint5 = 'https://localhost:5211/mitigantes/';


    constructor(private http: HttpClient) {
    }

    obtenerFactores(values: string): Observable<any> {
        return this.http.get<any>(
            this.endpoint + values
        );
    }

    obtenerMitigantes() {
        return this.http.post<any>(
            this.endpoint,
            null
        );
    }

    obtenerRiesgosPorFactor(values: any) {
        return this.http.post<any>(
            this.endpoint2,
            JSON.stringify(values)
        );
    }

    modificarRiesgo(values: any) {
        return this.http.put<any>(
            this.endpoint,
            JSON.stringify(values)
        );
    }

    modificarRiesgoEBR(values: any) {
        return this.http.put<any>(
            this.endpoint + 'ActualizarEBRFactor',
            JSON.stringify(values)
        );
    }

    modificarMitigante(values: any) {
        return this.http.put<any>(
            this.endpoint5,
            JSON.stringify(values)
        );
    }

    modificarRiesgoTabla(values: any) {
        return this.http.put<any>(
            this.endpoint3,
            JSON.stringify(values)
        );
    }

    modificarRiesgoFactoresMasivo(values: any) {
        return this.http.put<any>(
            this.endpoint + 'modificar-riesgo',
            JSON.stringify(values)
        );
    }

}
